<script>
import ModalImportComponent from '../features/ModalImportComponent';

export default {
    name: 'ModalImportView',
    extends: ModalImportComponent,
};
</script>
<template>
  <el-dialog
    v-model="conf.isVisible"
    :title="conf.title"
    class="modal-import"
    width="25%"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <fieldset>
        <legend>Seleccionar Archivo</legend>
        <el-row>
          <el-col :span="24">
            <el-upload
              class="upload-demo"
              action=""
              :before-upload="onUpload"
              :show-file-list="false"
            >
              <el-button
                size="small"
                type="primary"
              >
                Click para subir archivo
              </el-button>
              <template #tip>
                <div 
                  class="el-upload__tip"
                >
                  Solo archivos en formato Excel
                </div>
              </template>
            </el-upload>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="small"
          @click="onCancel"
        >Cancelar</el-button>
      </span>
    </template>
  </el-dialog>
</template>